export const getParentPath = (path: string, depth = 1): string => {
  let newPath = path;
  for (let i = 0; i < depth; i++) {
    newPath = newPath.slice(0, newPath.lastIndexOf("/"));
  }

  return newPath;
};
